/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { htmlspecialchars } from './util.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';

import { mjWidgetOverlayEditor } from './widget-overlay-editor.js';


export let MVTranslationsEditor = function($,mj) {

	function _build_ml_object( str, ui_locales ) {
		var obj = {};
		for( var i=0; i<ui_locales.length; ++i ) obj[ui_locales[i]] = str;
		return obj;
	}

	function open( elem, val, ctype, accept_cb, close_cb, ui_locales, ui_locale_display_names, default_ui_locale, options ) {

		var setup_cb = function( elem, val, ovl ) {
			var tag_name = elem.prop('tagName'),
				val_type = typeof val;
			if( val_type==='string' ) {
				if( val.length>0 && val[0]==='{' ) {
					// from json string
					try {
						val = JSON.parse(val);
					} catch( err ) {
						// use plain string
						val = _build_ml_object(val,ui_locales);
					}
				} else {
					// from simple string
					val = _build_ml_object(val,ui_locales);
				}
			} else if( val_type==='object' ) {
				// from object (no conversion required)
			}
			if( val===null ) val = _build_ml_object('',ui_locales);

			// add translation value inputs
			for( var i=0; i<ui_locales.length; ++i ) {
				var lk = ui_locales[i],
					ldn = ui_locale_display_names.hasOwnProperty(lk) ? ui_locale_display_names[lk] : lk,
					ltag_title = tag_name=='TEXTAREA' ? ldn+' ('+lk+')' : lk,
					ltag_class = tag_name=='TEXTAREA' ? 'ml-ltag ml-ltag-ta' : 'ml-ltag',
					ml_item = $( '<div class="ml-item"><span class="'+ltag_class+'">'+htmlspecialchars(ltag_title)+'</span></div>').appendTo(ovl),
					iv = val.hasOwnProperty(lk) ? val[lk] : ( val.hasOwnProperty(default_ui_locale) ? val[default_ui_locale] : '' );
				if( tag_name=='TEXTAREA' ) {
					$('<textarea class="ml-ltext" name="'+htmlspecialchars(lk,true,true)+'" />').val(iv).appendTo(ml_item);
				} else {
					$('<input class="ml-ltext" type="text" name="'+htmlspecialchars(lk,true,true)+'" />').val(iv).appendTo(ml_item);
				}
				// console.log({w:'LOGITEM',ml_item});
			}

			if( tag_name=='TEXTAREA' ) {
				var textareas = ovl.find('textarea.ml-ltext');
				var emode = ctype==='text/html' ? 'x-mj-i18n-html' : 'x-mj-i18n-text';
				textareas.each( function() {
					var self = $(this);
					self.mjCodeEditorWidget( {
						mode: emode,
						defered_init: true,
					} );
				} );
				textareas.focus( function() {
					var curr = $(this);
					var curr_name = curr.prop('name');
					textareas.each( function() {
						var self = $(this);
						if( self.prop('name')!=curr_name ) {
							self.css('height','');
							self.mjCodeEditorWidget('convertToTextArea');
						}
					} );
					curr.height(elem.height()||0);
					curr.mjCodeEditorWidget('convertToEditor');
				});
				ovl.find('.ml-ltag').addClass('link').click( function() {
					$(this).next('textarea').select();
				});
			} else {
				ovl.find('.ml-ltag').addClass('link').click( function() {
					$(this).next('input[type=text]').select();
				});
			}
		};

		var extract_cb = function( ovl ) {
			var out = {};
			ovl.find('textarea.ml-ltext').each( function() {
				$(this).mjCodeEditorWidget('convertToTextArea');
			} );
			ovl.find('textarea.ml-ltext,input.ml-ltext').each( function(e) {
				var inp = $(this);
				out[inp.prop('name')] = inp.val();
			} );
			// if all labels equal, then return simple string ...
			var prev_val=null, differ=false;
			for( var l in out ) {
				if( !out.hasOwnProperty(l) ) continue;
				if( prev_val!==null && prev_val!==out[l] ) {
					differ = true;
					break;
				}
				prev_val = out[l];
			}
			out = differ
				? ( ctype=='text/plain-string' ? JSON.stringify(out) : JSON.stringify(out,null,2) )
				: ( prev_val===null ? '' : prev_val );
			return out;
		};

		//var tmpP = elem.offsetParent();
		var tmpP = elem.closest('#page-right-container,.ui-dialog');
		if( tmpP.length===0 ) tmpP = elem.offsetParent();

		options = Object.assign( {WrapOverlayContents:false,OffsetParent:tmpP}, options );

		return mjWidgetOverlayEditor.open( elem, val, setup_cb, extract_cb, accept_cb, close_cb, options );
	}

	function open2( elem, val, ctype, accept_cb, close_cb, src_opts ) {
		var locales = src_opts.hasOwnProperty('locales') && src_opts.locales!==null ? src_opts.locales : mj.ui_locales;
		var locale_display_names = src_opts.hasOwnProperty('locale_display_names') && src_opts.locale_display_names!==null ? src_opts.locale_display_names : mj.ui_locale_display_names;
		var default_locale = src_opts.hasOwnProperty('default_locale') && src_opts.default_locale!==null ? src_opts.default_locale : mj.ui_locales[0];
		var overlay_options = src_opts.hasOwnProperty('overlay_options') ? src_opts.overlay_options : {};
		overlay_options.ovl_sfx = src_opts.ovl_sfx ?? overlay_options.ovl_sfx ?? '';
		return open( elem, val, ctype, accept_cb, close_cb, locales, locale_display_names, default_locale, overlay_options );
	}

	function close( ovl_sfx ) {
		return mjWidgetOverlayEditor.close(ovl_sfx??'');
	}

	return {
		open: open,
		open2: open2,
		close: close,
	};
}(jQuery,mj); // namespace MVTranslationsEditor
